export default "__VITE_ASSET__DnhdyiLE__"